import { Directive, Input, OnInit, Optional, ElementRef } from '@angular/core';
import { DialogService } from './dialog.service';
import { DialogRef } from './dialog-ref';

/** Counter used to generate unique IDs for dialog elements. */
let dialogElementUid = 0;

/**
 * Title of a dialog element. Stays fixed to the top of the dialog when scrolling.
 */
@Directive({
  // tslint:disable-next-line
  selector: '[dialog-title], dialog-title',
  // tslint:disable-next-line: no-host-metadata-property
  host: {
    class: 'dialog-title',
    '[id]': 'id'
  }
})
// tslint:disable-next-line:directive-class-suffix
export class DialogContainerTitle implements OnInit {
  @Input() id = `dialog-title-${dialogElementUid++}`;

  constructor(
    @Optional() private _dialogRef: DialogRef<any>,
    private _elementRef: ElementRef<HTMLElement>,
    private _dialog: DialogService
  ) {}

  ngOnInit() {
    if (!this._dialogRef) {
      this._dialogRef = getClosestDialog(
        this._elementRef,
        this._dialog.openDialogs
      );
    }

    if (this._dialogRef) {
      Promise.resolve().then(() => {
        const container = this._dialogRef._containerInstance;

        if (container && !container._ariaLabelledBy) {
          container._ariaLabelledBy = this.id;
        }
      });
    }
  }
}

/**
 * Scrollable content container of a dialog.
 */
@Directive({
  // tslint:disable-next-line
  selector: `[dialog-content], dialog-content`,
  // tslint:disable-next-line: no-host-metadata-property
  host: { class: 'dialog-content' }
})
// tslint:disable-next-line:directive-class-suffix
export class DialogContainerContent {}

/**
 * Container for the bottom action buttons in a dialog.
 * Stays fixed to the bottom when scrolling.
 */
@Directive({
  // tslint:disable-next-line
  selector: `[dialog-actions], dialog-actions`,
  // tslint:disable-next-line: no-host-metadata-property
  host: { class: 'dialog-actions' }
})
// tslint:disable-next-line:directive-class-suffix
export class DialogContainerActions {}

/**
 * Finds the closest DialogRef to an element by looking at the DOM.
 * @param element Element relative to which to look for a dialog.
 * @param openDialogs References to the currently-open dialogs.
 */
function getClosestDialog(
  element: ElementRef<HTMLElement>,
  openDialogs: DialogRef<any>[]
) {
  let parent: HTMLElement | null = element.nativeElement.parentElement;

  while (parent && !parent.classList.contains('dialog-container')) {
    parent = parent.parentElement;
  }

  return parent ? openDialogs.find(dialog => dialog.id === parent.id) : null;
}
